/*
 *
 * TechnicalIntervention constants
 *
 */

export const UPLOAD_IMAGE = 'app/TechnicalIntervention/UPLOAD_IMAGE';
